import { render, staticRenderFns } from "./DevNav.vue?vue&type=template&id=49990c92&"
import script from "./DevNav.vue?vue&type=script&lang=js&"
export * from "./DevNav.vue?vue&type=script&lang=js&"
import style0 from "./DevNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports